/* ==========================================================================
   CSA FAQ Accordion JavaScript
   Silky-Smooth Slide Expansion & Theme Editor Realtime Lifecycle Management
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCSAFaqAccordions();
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section-csa-faq-accordion') || event.target.querySelector('.csa-faq-accordion-wrap')) {
    initCSAFaqSection(event.target);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  const blockEl = event.target;
  if (blockEl && blockEl.classList.contains('csa-faq-item')) {
    openFaqItem(blockEl);
  }
});

function initCSAFaqAccordions() {
  const sections = document.querySelectorAll('.csa-faq-section');
  sections.forEach(function (section) {
    initCSAFaqSection(section);
  });
}

function initCSAFaqSection(section) {
  const faqItems = section.querySelectorAll('.csa-faq-item');

  faqItems.forEach(function (item) {
    const btn = item.querySelector('.csa-faq-btn');
    const content = item.querySelector('.csa-faq-content');

    if (!btn || !content) return;

    // Check if open by default
    if (item.classList.contains('is-open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        closeFaqItem(item);
      } else {
        openFaqItem(item);
      }
    });
  });
}

function openFaqItem(item) {
  const content = item.querySelector('.csa-faq-content');
  if (!content) return;

  item.classList.add('is-open');
  content.style.maxHeight = content.scrollHeight + 30 + 'px';
}

function closeFaqItem(item) {
  const content = item.querySelector('.csa-faq-content');
  if (!content) return;

  item.classList.remove('is-open');
  content.style.maxHeight = '0px';
}
